import React from "react";
import { H1 } from "@shoptet/ui";
import { Trans, useTranslation } from "react-i18next";
import MetaWizardStepper from "./MetaWizardStepper";

const MetaWizardHeader = ({ activeStep }: { activeStep: number }) => {
  const { t } = useTranslation("translation", { keyPrefix: "Wizard Meta" });
  return (
    <div>
      <H1>
        {/* The headline is one colour now. The `<span>` stays mapped because the translations carry
            it in every locale - it just no longer tints what it wraps. */}
        <Trans components={{ span: <span /> }} i18nKey="Headline" t={t} />
      </H1>
      <div style={{ margin: "-12px auto 12px", maxWidth: "808px" }}>
        <MetaWizardStepper activeStep={activeStep} />
      </div>
    </div>
  );
};

export default MetaWizardHeader;
